// Author Shi Wenlong
// Date 2021-06-07 14:32:06

class SithMesQualityToolCheckResult {
constructor({
        id = null,
        uploadDate = '',
        uploadPath = '',
        fileName = '',
        fileSize = '',
        remark = ''}
= {}) {
    this.id = id;
    this.uploadDate = uploadDate;
    this.uploadPath = uploadPath;
    this.fileName = fileName;
    this.fileSize = fileSize;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesQualityToolCheckResult();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.quality.sithMesQualityToolCheckResult.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'uploadDate',
        label: 'label.sith.quality.sithMesQualityToolCheckResult.grid.uploadDate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'uploadPath',
        label: 'label.sith.quality.sithMesQualityToolCheckResult.grid.uploadPath',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'fileName',
        label: 'label.sith.quality.sithMesQualityToolCheckResult.grid.fileName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'fileSize',
        label: 'label.sith.quality.sithMesQualityToolCheckResult.grid.fileSize',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.quality.sithMesQualityToolCheckResult.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    uploadDateRteFilter : "",
    uploadDateLteFilter : "",
    uploadPathFilter : "",
    fileNameFilter : "",
    fileSizeFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'uploadDateRteFilter',
        label: 'label.sith.quality.sithMesQualityToolCheckResult.filter.uploadDateRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'uploadDateLteFilter',
        label: 'label.sith.quality.sithMesQualityToolCheckResult.filter.uploadDateLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'uploadPathFilter',
        label: 'label.sith.quality.sithMesQualityToolCheckResult.filter.uploadPath',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'fileNameFilter',
        label: 'label.sith.quality.sithMesQualityToolCheckResult.filter.fileName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'fileSizeFilter',
        label: 'label.sith.quality.sithMesQualityToolCheckResult.filter.fileSize',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'uploadDate',
        label: 'label.sith.quality.sithMesQualityToolCheckResult.entity.uploadDate',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'uploadPath',
        label: 'label.sith.quality.sithMesQualityToolCheckResult.entity.uploadPath',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'fileName',
        label: 'label.sith.quality.sithMesQualityToolCheckResult.entity.fileName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'fileSize',
        label: 'label.sith.quality.sithMesQualityToolCheckResult.entity.fileSize',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.quality.sithMesQualityToolCheckResult.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesQualityToolCheckResult, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
